import { Container } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Nav/Navbar";
import Homepage from "./page/Homepage";
import Result from "./page/Result";
import { styled } from '@mui/material/styles';
import Demo from "./page/Demo";
import Network from "./page/Network";
import About from "./page/About";

const Body = styled((props) => (
    <Container
        maxWidth="xxxl"
        disableGutters
        {...props}
    />
))(({ theme }) => ({
    position: "position",
    overflow: "hidden",
}));

function App() {
    const theme = createTheme({
        components: {
            MuiCard: {
                styleOverrides: {
                    root: {
                        borderRadius: 20,
                    }
                },
            }
        },
        breakpoints: {
            values: {
                xs: 0,
                sm: 574,
                md: 768,
                lg: 900,
                xl: 1072,
                xxl: 1536,
            }
        },
        typography: {
            htmlFontSize: 10,
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <Body>
                <Navbar />
                <Routes>
                    <Route path="/" element={<Homepage />} />
                    <Route path="/demo" element={<Demo />} />
                    <Route path="/network" element={<Network />} />
                    <Route path="/result" element={<Result />} />
                    <Route path="/about" element={<About />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Body>
        </ThemeProvider>
    );
}

export default App;
